import { Col, Form } from 'antd'
import React, { FunctionComponent, memo } from 'react'

import { BUYBACK_FIELD as FIELD } from '../../../common/buybackTypes'

export const BuybackFormSummaryFragmentRentDuration: FunctionComponent = memo(
  () => {
    const rentalDurationMonths = Form.useWatch(FIELD.RentDurationMonths) ?? 0

    return (
      <Col xs={24} md={12} xl={8} className="text-center">
        <div className="mb-2">Délka nájmu / garance zpětného odkupu</div>
        <div className="text-2xl">{`${rentalDurationMonths} měs.`}</div>
      </Col>
    )
  }
)
